// Sprite positions are semantic and identical for both skins. Never used for
// backend brand, banner, activity, provider or game-cover URLs.
export const artworkRoles = ['calendar', 'people', 'crown', 'headset', 'wallet', 'bank', 'lock', 'key', 'profile', 'record', 'download', 'coin', 'shield', 'chest', 'wheel', 'fire', 'slots', 'game', 'bingo', 'grid', 'clock', 'heart', 'logout', 'announcement', 'copy']
export const artworkAliases = { user: 'profile', users: 'people', gift: 'chest', award: 'crown', club: 'game', star: 'crown', clover: 'coin' }
const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
const knownSheets = new Set()
const knownPosterSheets = new Set()
// Only bundled decorative assets are skinned. Backend URLs are never matched.
const bundledRoles = new Map([
    [require('@/assets/event/reward-chest.png'), 'chest'],
    [require('@/assets/notification/icon_info2.png'), 'record'],
    [require('@/assets/notification/icon_info.png'), 'record'],
    [require('@/assets/notification/icon_laba.png'), 'announcement'],
    [require('@/assets/design-refresh/wheel-coins-v1.svg'), 'coin'],
    [require('@/assets/turntable/empty-money.png'), 'chest'],
    [require('@/assets/turntable/money_icon.png'), 'coin'],
    [require('@/assets/turntable/icon-money.png'), 'coin'],
    [require('@/assets/mobile-home/ui/redeem.svg'), 'chest'],
    [require('@/assets/mobile-home/ui/announcement.svg'), 'announcement'],
    ...['menu', 'menu-active', 'casino', 'casino-active', 'affiliate', 'affiliate-active', 'vip', 'vip-active', 'account', 'account-active'].map((file, index) => [require('@/assets/mobile-home/ui/' + file + '.svg'), ['grid', 'game', 'people', 'crown', 'profile'][Math.floor(index / 2)]]),
    ...Object.entries({ popular: 'fire', slots: 'slots', mini: 'game', bingo: 'bingo', providers: 'grid', recent: 'clock', favorites: 'heart' }).map(([file, role]) => [require('@/assets/mobile-home/categories/' + file + '.png'), role]),
    ...Object.entries({ 'check-in': 'calendar', 'group-purchase': 'people', 'loss-support': 'shield', salary: 'wallet' }).map(([file, role]) => [require('@/assets/mobile-home/activities/' + file + '.svg'), role])
])

export function artworkSource(sheet, name) {
    const index = artworkRoles.indexOf(artworkAliases[name] || name)
    return index < 0 ? '' : `${sheet}#skin-art=${index}`
}

export function artworkStyle(source) {
    const poster = String(source || '').match(/^(.*)#skin-poster=([0-3])$/)
    if (poster) return { backgroundImage: `url("${poster[1]}")`, backgroundSize: '400% 100%', backgroundPosition: `${Number(poster[2]) * 100 / 3}% 0%`, backgroundRepeat: 'no-repeat' }
    const match = String(source || '').match(/^(.*)#skin-art=(\d+)$/)
    if (!match || +match[2] >= artworkRoles.length) return null
    const index = +match[2]
    return { backgroundImage: `url("${match[1]}")`, backgroundSize: '500% 500%', backgroundPosition: `${(index % 5) * 25}% ${Math.floor(index / 5) * 25}%`, backgroundRepeat: 'no-repeat' }
}

export const themeArtwork = {
    bind(element, binding, vnode) { applyCurrent(element, binding.value, vnode.context) },
    update(element, binding, vnode) { applyCurrent(element, binding.value, vnode.context) }
}

function applyCurrent(element, source, context) {
    const sheet = context?.$themeImage?.('artwork.icons')
    const posterSheet = context?.$themeImage?.('artwork.affiliatePosters')
    if (sheet) knownSheets.add(sheet)
    if (posterSheet) knownPosterSheets.add(posterSheet)
    const index = String(source || '').match(/#skin-art=(\d+)$/)?.[1]
    const poster = String(source || '').match(/#skin-poster=([0-3])$/)?.[1]
    const ownedPoster = poster !== undefined && knownPosterSheets.has(String(source).split('#skin-poster=')[0])
    const ownedSprite = index !== undefined && knownSheets.has(String(source).split('#skin-art=')[0])
    const role = bundledRoles.get(source)
    const resolved = posterSheet && ownedPoster ? `${posterSheet}#skin-poster=${poster}` : sheet && ownedSprite ? `${sheet}#skin-art=${index}` : sheet && role ? artworkSource(sheet, role) : source
    if (element.__skinResolvedSource === resolved) return
    element.__skinResolvedSource = resolved
    apply(element, resolved, (!!sheet && (ownedSprite || !!role)) || (!!posterSheet && ownedPoster))
}

function apply(element, source, isArtwork) {
    const style = isArtwork ? artworkStyle(source) : null
    if (!style) {
        if (element.__skinArtwork) {
            Object.keys(element.__skinArtwork).forEach(key => { element.style[key] = element.__skinArtwork[key] })
            element.removeAttribute('data-skin-artwork')
            element.removeAttribute('data-skin-poster')
            delete element.__skinArtwork
            if (source) element.src = source
        }
        return
    }
    if (!element.__skinArtwork) element.__skinArtwork = Object.fromEntries(Object.keys(style).map(key => [key, element.style[key]]))
    Object.assign(element.style, style)
    element.src = transparentPixel
    element.setAttribute('data-skin-artwork', String(source).split(/#skin-(?:art|poster)=/)[1])
    const poster = String(source).match(/#skin-poster=([0-3])$/)
    if (poster) element.setAttribute('data-skin-poster', poster[1])
    else element.removeAttribute('data-skin-poster')
}
